import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { EText, ELink } from "./cms/Editable";
import { useSite } from "../context/SiteContext";

export default function Footer() {
  const { get, editMode, save } = useSite();
  const social = (k, d, Icon, testid) => {
    const href = get(k, d);
    return editMode ? (
      <button type="button" onClick={() => { const v = window.prompt("Link URL", href); if (v !== null) save(k, v.trim()); }}
        className="p-2 rounded-full bg-white/10 hover:bg-white/20 cms-editable" data-testid={testid}><Icon size={18} /></button>
    ) : (
      <a href={href} target="_blank" rel="noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20" data-testid={testid}><Icon size={18} /></a>
    );
  };
  const email = get("footer.email", "seymour@isoharts.com");

  return (
    <footer className="bg-brand-ink text-white/90 mt-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <EText k="footer.brand" as="h3" className="font-display text-3xl font-semibold text-white block">Isoharts</EText>
          <EText k="footer.tagline" as="p" className="text-brand-gold text-xs uppercase tracking-widest mt-1 block">International Soul of Healing Arts</EText>
          <EText k="footer.about" as="p" multiline className="mt-3 text-sm text-white/70 max-w-md leading-relaxed block">
            Heal Yourself. Align Your Energy. Live Your Dharma. Home of the Zenergize Holistic Health Club and free Chinese Astrology tools by Seymour Koblin.
          </EText>
          <div className="mt-5 flex gap-3">
            {social("footer.facebook", "https://facebook.com", Facebook, "footer-facebook")}
            {social("footer.instagram", "https://instagram.com", Instagram, "footer-instagram")}
          </div>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/packages" className="hover:text-brand-gold">Membership</Link></li>
            <li><Link to="/shop" className="hover:text-brand-gold" data-testid="footer-shop">Shop</Link></li>
            <li><Link to="/events" className="hover:text-brand-gold">Events & Retreats</Link></li>
            <li><ELink k="footer.astrology" to="/chinese-astrology" className="hover:text-brand-gold" testid="footer-astrology">Chinese Astrology</ELink></li>
            <li><Link to="/privacy-policy" className="hover:text-brand-gold" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-brand-gold" data-testid="footer-terms">Terms of Service</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">Contact</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /> <EText k="footer.address">4767 Ocean Boulevard, San Diego, CA 92109</EText></li>
            <li className="flex items-center gap-2"><Mail size={16} />
              {editMode ? <EText k="footer.email">seymour@isoharts.com</EText> : <a href={`mailto:${email}`} className="hover:text-brand-gold" data-testid="footer-email">{email}</a>}
            </li>
            <li className="flex items-center gap-2"><Phone size={16} /> <EText k="footer.phone">(858) 926-5845</EText></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-5 sm:px-8 py-6">
        <EText k="footer.disclaimer" as="p" multiline className="mx-auto max-w-4xl text-center text-[11px] leading-relaxed tracking-wide text-white/50 uppercase block">
          Isoharts is a 501(c)(3) spiritually based nonprofit organization. All education is for personal benefit and self development. Nothing on this site is intended to diagnose, treat, cure, or prevent any disease and is not a substitute for professional medical advice.
        </EText>
        <p className="mt-3 text-center text-xs text-white/40">© {new Date().getFullYear()} <EText k="footer.copyright">Isoharts. All rights reserved.</EText></p>
      </div>
    </footer>
  );
}
